import appApi from "../utils/AppApi";
import API_ENDPOINTS from "../utils/endPoints";

export const createTicket = async (ticket) => {
  return appApi.post(API_ENDPOINTS.CREATE_TICKET, { ...ticket });
};

export const createHubbleForm = async (formData) => {
  return appApi.post(API_ENDPOINTS.CREATE_HUBBLE_FORM, { ...formData });
};

export const getMyUploads = async () => {
  return appApi.get(API_ENDPOINTS.GET_MY_UPLOADS);
};

export const getMyUpload = async (id) => {
  return appApi.get(API_ENDPOINTS.GET_MY_UPLOAD(id));
};

export const updateHubbleForm = async (id, formData) => {
  return appApi.patch(API_ENDPOINTS.UPDATE_HUBBLE_FORM(id), { ...formData });
};

export const removeMyUpload = async (id) => {
  return appApi.delete(API_ENDPOINTS.REMOVE_UPLOAD(id));
};

export const getMyPrice = async () => {
  return appApi.get(API_ENDPOINTS.GET_MY_PRICE);
};

export const purchase = async () => {
  return appApi.get(API_ENDPOINTS.PURCHASE);
};

export const getRefereeList = async (referee, searchStr) => {
  return appApi.get(API_ENDPOINTS.GET_HUBBLE_REFEREE(referee, searchStr));
};

export const isReferee = async () => {
  return appApi.get(API_ENDPOINTS.IS_REFEREE);
};

export const refereeForm = async (data) => {
  return appApi.post(API_ENDPOINTS.REFEREE_FORM, { ...data });
};

export const updateReferee = async (id, data) => {
  return appApi.patch(API_ENDPOINTS.UPDATE_REFEREE_BY_ID(id), { ...data });
};

export const getRefereeByFormId = async (id) => {
  return appApi.get(API_ENDPOINTS.GET_REFEREE_BY_FORM_iD(id));
};

export const createWordGameTicket = async () => {
  return appApi.post(API_ENDPOINTS.CREATE_WORD_GAME_TICKET);
};

export const createWordGameTicketUsingKey = async () => {
  return appApi.post(API_ENDPOINTS.CREATE_WORD_GAME_TICKET, { useKey: true });
};

export const getWordGameById = async (id) => {
  return appApi.get(API_ENDPOINTS.GET_WORD_GAME_TICKET_BY_ID(id));
};

export const submitWordGame = async (id, word) => {
  return appApi.patch(API_ENDPOINTS.SUBMIT_WORD_GAME(id), { userWord: word });
};

export const getWordGameTodayCount = async () => {
  return appApi.get(API_ENDPOINTS.GET_WORD_GAME_COUNT);
};

export const getWordGameEventById = async (id) => {
  return appApi.get(API_ENDPOINTS.GET_WORD_GAME_EVENT_BY_ID(id));
};

export const createWordGameTicketV2 = async (eventId) => {
  return appApi.post(API_ENDPOINTS.CREATE_WORD_GAME_TICKET_v2, { eventId });
};